global.BASE_URL = "https://be.aprisla.my.id"; // url backend
